import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 페이지 전환 시 스크롤을 최상단으로 초기화
 */
function useScrollReset() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}

export default useScrollReset;
